var $ = require('jquery');

$(function () {
    // mobile accordion

    $('.tabbed-content__tab-content__group').on('click', function (e) {
        if (!$(e.target).closest('.tabbed-content__tab-content__item').length) {
            e.preventDefault();
            $(this).siblings('.tabbed-content__tab-content__group')
                .children('.tabbed-content__tab-content__name').removeClass('selected')
                .next('.tabbed-content__tab-content__item').slideUp();
            $(this).children('.tabbed-content__tab-content__name').toggleClass('selected')
                .next('.tabbed-content__tab-content__item').slideToggle();
            $(this).find('.tabbed-list-links__tab-content__item__links__slider').css('display', 'block');
            $(this).find('.tabbed-list-links__tab-content__item__links__slider').get(0).slick.setPosition();
        }
    });

    var tabNames = new Array(); //list of recorded tab names from the querystring

    //Logic for querystring tab activation and default desktop tabs
    $('.tabbed-content').each(function () {
        var t = $(this);
        //desktop tabs default tab
        t.find('.tabbed-content__tabs__tab:first').addClass('selected');
        t.find('.tabbed-content__tab-content__item:first').addClass('selected');

        //mobile accordion default tab
        t.find('.tabbed-content__tab-content .tabbed-content__tab-content__group:first .tabbed-content__tab-content__name').addClass('selected');
        t.find('.tabbed-content__tab-content .tabbed-content__tab-content__group:first .tabbed-content__tab-content__item').addClass('selected');

        //desktop tab click event
        t.find('.tabbed-content__tabs__tab').click(function () {
            var clickedTab = $(this);
            var clickedTabId = clickedTab.children().data('tab-id');
            var clickedTabContent = t.find('.tabbed-content__tab-content__group')
                .children('.tabbed-content__tab-content__item[data-tab-id="' + clickedTabId + '"]');
            //deactivate current tab
            t.find('.tabbed-content__tabs__tab').removeClass('selected');
            t.find('.tabbed-content__tab-content__item').removeClass('selected');
            //activate new tab
            clickedTab.addClass('selected');
            clickedTabContent.addClass('selected');
        });

        var tabName = t.data('tab-name');
        var tabCount = t.find('.tabbed-content__tabs__tab').length;
        var tabIndex = $.QueryStringTabActivation(tabName, tabCount);
        if (tabIndex !== 999 && !tabNames.includes(tabName)) {
            var newTab = t.find('.tabbed-content__tab__name[data-tab-id="' + tabIndex + '"]');
            var newTabContent = t.find('.tabbed-content__tab-content__item[data-tab-id="' + tabIndex + '"]');
            var newAccordionTabContent = t.find('.tabbed-content__tab-content__group .tabbed-content__tab-content__item[data-tab-id="' + tabIndex + '"]');
            var newAccordionTab = newAccordionTabContent.prev();
            //deactivate current desktop tab
            t.find('.tabbed-content__tabs__tab.selected').removeClass('selected');
            t.find('.tabbed-content__tab-content__item.selected').removeClass('selected');
            //deactivate current mobile accordion tab
            t.find('.tabbed-content__tab-content__group:first .tabbed-content__tab-content__item').removeClass('selected');
            t.find('.tabbed-content__tab-content__group:first .tabbed-content__tab-content__name').removeClass('selected');
            //activate new desktop tab
            newTab.parent().addClass('selected');
            newTabContent.addClass('selected');
            //activate new mobile accordion tab
            newAccordionTab.addClass('selected');
            newAccordionTabContent.addClass('selected');
            $.ScrollToLocation(newTabContent, 400, false);
            tabNames.push(tabName);
        }
    });
    // mobile link carousel

    $('.tabbed-list-links__tab-content__item__links__slider').slick({
        arrows: true,
        customPaging: function (slick, index) {
            return '<span class="number">' + (index + 1) + '</span>';
        },
        dots: true,
        mobileFirst: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        responsive: [{
            breakpoint: 767,
            settings: 'unslick'
        }],
        rtl: window.GenericUtilities.isRTL()
    });
    // to get slick slider to initialize on screen resize
    // https://github.com/kenwheeler/slick/issues/1730
    $(window).on('resize orientationchange', function () {
        $('.tabbed-list-links__tab-content__item__links__slider').slick('resize');
    });
});